import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.svg'
import _imports_1 from '@/assets/github-mark.svg'


const _hoisted_1 = { class: "navbar bg-light" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  class: "mx-3",
  height: "27",
  src: _imports_0,
  width: "27"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Input Lag Test", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-secondary ms-auto" }, [
  /*#__PURE__*/_createTextVNode(" Made by "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "git-profile-link text-secondary",
    href: "https://github.com/bananasmoothii"
  }, "Bananasmoothii"),
  /*#__PURE__*/_createElementVNode("a", { href: "https://github.com/bananasmoothii/input-lag-test" }, [
    /*#__PURE__*/_createElementVNode("img", {
      alt: "GitHub",
      class: "mx-3",
      height: "27.2",
      src: _imports_1,
      width: "27.2"
    })
  ])
], -1)
const _hoisted_6 = { class: "router-view mx-auto px-5 mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_RouterLink, {
          class: "navbar-brand",
          to: "/"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _hoisted_4
          ]),
          _: 1
        }),
        _hoisted_5
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_RouterView)
    ])
  ], 64))
}